<template>
  <transition name="modal">
    <div class="modal fade show d-block" role="dialog">
      <div class="modal-dialog modal-dialog-centered z-1" :class="size ? `modal-${size}` : null" role="document">
        <div class="modal-content p-3" :class="contentClass">

          <div class="modal-header justify-content-center">
            <slot name="header"></slot>
            <button type="button" class="close text-primary border-0 border-primary" aria-label="Close" @click="$emit('close', $event)">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" aria-hidden="true" viewBox="0 0 18 18"><rect width="100%" height="100%" fill="none"/><g fill="currentColor" class="currentLayer"><path d="M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"/><path d="M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"/><path d="M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"/></g></svg>
            </button>
          </div>

          <div class="modal-body justify-content-center" :class="bodyClass">
            <slot name="body"></slot>
          </div>

          <div class="modal-footer justify-content-center">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show z-0" @click="$emit('close')"></div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    bodyClass: { type: [String, Array, Object], default: null },
    contentClass: { type: [String, Array, Object], default: null },
    size: { type: String, default: null }
  }
}
</script>

<style lang="scss" scoped>
/*
 * The following styles are auto-applied to elements with
 * transition = "modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-header {

  .close {
    position: absolute;
    right: 0;
    top: 0;
    margin: 0;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue